import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const commonRoutes = [
    {
        path: "/login",
        name: "login",
        meta: { title: "登录" },
        component: () => import("../components/Login.vue"),
    },

    {
        path: "/404",
        name: "404",
        meta: { title: "404" },
        component: () => import("../components/404.vue"),
    },
    { path: "/", redirect: "/home" },
];

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    home: {
        path: "home",
        name: "home",
        meta: { title: "主页" },
        component: () => import("../views/Home.vue"),
    },

    floor: {
        path: "floor",
        name: "floor",
        meta: { title: "底板" },
        component: () => import("../views/floor.vue"),
    },
    floorCarving: {
        path: "floorCarving",
        name: "floorCarving",
        meta: { title: "底板雕刻设置" },
        component: () => import("../views/set/floorCarving.vue"),
    },
    other: {
        path: "other",
        name: "other",
        meta: { title: "其他工艺设置" },
        component: () => import("../views/set/other.vue"),
    },
    panelCarving: {
        path: "panelCarving",
        name: "panelCarving",
        meta: { title: "面板板雕刻设置" },
        component: () => import("../views/set/panelCarving.vue"),
    },
    superwordGrouted: {
        path: "superwordGrouted",
        name: "superwordGrouted",
        meta: { title: "超级字灌胶设置" },
        component: () => import("../views/superSet/superwordGrouted.vue"),
    },
    superwordFloor: {
        path: "superwordFloor",
        name: "superwordFloor",
        meta: { title: "超级字底板设置" },
        component: () => import("../views/superSet/superwordFloor.vue"),
    },

    superwordSideband: {
        path: "superwordSideband",
        name: "superwordSideband",
        meta: { title: "超级字边带设置" },
        component: () => import("../views/superSet/superwordSideband.vue"),
    },
    superwordCarving: {
        path: "superwordCarving",
        name: "superwordCarving",
        meta: { title: "超级字雕刻设置" },
        component: () => import("../views/superSet/superwordCarving.vue"),
    },

    stainlessSteelPanel: {
        path: "stainlessSteelPanel",
        name: "stainlessSteelPanel",
        meta: { title: "不锈钢字面板设置" },
        component: () => import("../views/stainlessSet/stainlessSteelPanel.vue"),
    },

    stainlessSteelSideband: {
        path: "stainlessSteelSideband",
        name: "stainlessSteelSideband",
        meta: { title: "不锈钢字边带板设置" },
        component: () => import("../views/stainlessSet/stainlessSteelSideband.vue"),
    },
    stainlessSteelSmall: {
        path: "stainlessSteelSmall",
        name: "stainlessSteelSmall",
        meta: { title: "不锈钢字小边设置" },
        component: () => import("../views/stainlessSet/stainlessSteelSmall.vue"),
    },
    stainlessSteelFloor: {
        path: "stainlessSteelFloor",
        name: "stainlessSteelFloor",
        meta: { title: "不锈钢字底板设置" },
        component: () => import("../views/stainlessSet/stainlessSteelFloor.vue"),
    },
    stainlessSteelCarving: {
        path: "stainlessSteelCarving",
        name: "stainlessSteelCarving",
        meta: { title: "不锈钢字雕刻设置" },
        component: () => import("../views/stainlessSet/stainlessSteelCarving.vue"),
    },
    boundlessCarving: {
        path: "boundlessCarving",
        name: "boundlessCarving",
        meta: { title: "无边字雕刻设置" },
        component: () => import("../views/borderlessSet/boundlessCarving.vue"),
    },
    boundlessPanel: {
        path: "boundlessPanel",
        name: "boundlessPanel",
        meta: { title: "无边字面板设置" },
        component: () => import("../views/borderlessSet/boundlessPanel.vue"),
    },
    boundlessFloor: {
        path: "boundlessFloor",
        name: "boundlessFloor",
        meta: { title: "无边字底板设置" },
        component: () => import("../views/borderlessSet/boundlessFloor.vue"),
    },
    boundlessSideband: {
        path: "boundlessSideband",
        name: "boundlessSideband",
        meta: { title: "无边字边带设置" },
        component: () => import("../views/borderlessSet/boundlessSideband.vue"),
    },
    miniCloutPanel: {
        path: "miniCloutPanel",
        name: "miniCloutPanel",
        meta: { title: "迷你字面板雕刻管理" },
        component: () => import("../views/material/miniCloutPanel.vue"),
    },
    miniCloutFloor: {
        path: "miniCloutFloor",
        name: "miniCloutFloor",
        meta: { title: "迷你字底板雕刻管理" },
        component: () => import("../views/material/miniCloutFloor.vue"),
    },
    wasteManage: {
        path: "wasteManage",
        name: "wasteManage",
        meta: { title: "废料管理" },
        component: () => import("../views/material/wasteManage.vue"),
    },
    offer: {
        path: "offer",
        name: "offer",
        meta: { title: "报价设置" },
        component: () => import("../views/set/offer.vue"),
    },
    panel: {
        path: "panel",
        name: "panel",
        meta: { title: "面板" },
        component: () => import("../views/panel.vue"),
    },

    floorFile: {
        path: "floorFile",
        name: "floorFile",
        meta: { title: "迷你字底板文件" },
        component: () => import("../views/floorFile.vue"),
    },
    panelFile: {
        path: "panelFile",
        name: "panelFile",
        meta: { title: "迷你字面板文件" },
        component: () => import("../views/panelFile.vue"),
    },
    carving: {
        path: "carving",
        name: "carving",
        meta: { title: "超级字雕刻文件" },
        component: () => import("../views/file/carving.vue"),
    },
    sideband: {
        path: "sideband",
        name: "sideband",
        meta: { title: "超级字边带文件" },
        component: () => import("../views/file/sideband.vue"),
    },
    superFloor: {
        path: "superFloor",
        name: "superFloor",
        meta: { title: "超级字底板文件" },
        component: () => import("../views/file/superFloor.vue"),
    },
    steelPanelFile: {
        path: "steelPanelFile",
        name: "steelPanelFile",
        meta: { title: "不锈钢字面板文件" },
        component: () => import("../views/file/steelPanelFile.vue"),
    },
    steelFloorFile: {
        path: "steelFloorFile",
        name: "steelFloorFile",
        meta: { title: "不锈钢字底板文件" },
        component: () => import("../views/file/steelFloorFile.vue"),
    },
    steelSmallFile: {
        path: "steelSmallFile",
        name: "steelSmallFile",
        meta: { title: "不锈钢字小边文件" },
        component: () => import("../views/file/steelSmallFile.vue"),
    },
    steelSidebandFile: {
        path: "steelSidebandFile",
        name: "steelSidebandFile",
        meta: { title: "不锈钢字边带文件" },
        component: () => import("../views/file/steelSidebandFile.vue"),
    },
    orderInfo: {
        path: "orderInfo",
        name: "orderInfo",
        meta: { title: "订单明细" },
        component: () => import("../views/order/orderInfo.vue"),
    },
    archiving: {
        path: "archiving",
        name: "archiving",
        meta: { title: "文件存档" },
        component: () => import("../views/archiving.vue"),
    },
    unpacked: {
        path: "unpacked",
        name: "unpacked",
        meta: { title: "未拼版" },
        component: () => import("../views/unpacked.vue"),
    },

    packed: {
        path: "packed",
        name: "packed",
        meta: { title: "已拼版" },
        component: () => import("../views/packed.vue"),
    },
    completed: {
        path: "completed",
        name: "completed",
        meta: { title: "已完成" },
        component: () => import("../views/completed.vue"),
    },
    statistics: {
        path: "statistics",
        name: "statistics",
        meta: { title: "材料统计" },
        component: () => import("../views/material/statistics.vue"),
    },
    fontLibrary: {
        path: "fontLibrary",
        name: "fontLibrary",
        meta: { title: "材料统计" },
        component: () => import("../views/fontLibrary.vue"),
    },
    customer: {
        path: "customer",
        name: "customer",
        meta: { title: "客户管理" },
        component: () => import("../views/order/customer.vue"),
    },
    // password: {
    //     path: 'password',
    //     name: 'password',
    //     meta: { title: '修改密码' },
    //     component: () => import('../views/Password.vue'),
    // },
    msg: {
        path: "msg",
        name: "msg",
        meta: { title: "通知消息" },
        component: () => import("../views/Msg.vue"),
    },
    userinfo: {
        path: "userinfo",
        name: "userinfo",
        meta: { title: "用户信息" },
        component: () => import("../views/UserInfo.vue"),
    },
    staff: {
        path: "staff",
        name: "staff",
        meta: { title: "员工管理" },
        component: () => import("../views/order/staff.vue"),
    },

    product: {
        path: "product",
        name: "product",
        meta: { title: "产品设置" },
        component: () => import("../views/order/product.vue"),
    },

    collection: {
        path: "collection",
        name: "collection",
        meta: { title: "收款设置" },
        component: () => import("../views/order/collection.vue"),
    },

    distribution: {
        path: "distribution",
        name: "distribution",
        meta: { title: "配送设置" },
        component: () => import("../views/order/distribution.vue"),
    },

    orderManagement: {
        path: "orderManagement",
        name: "orderManagement",
        meta: { title: "订单管理" },
        component: () => import("../views/order/orderManagement.vue"),
    },

    transactionDetails: {
        path: "transactionDetails",
        name: "transactionDetails",
        meta: { title: "收支明细" },
        component: () => import("../views/order/transactionDetails.vue"),
    },

    uvFile: {
        path: "uvFile",
        name: "uvFile",
        meta: { title: "收支明细" },
        component: () => import("../views/order/uvFile.vue"),
    },

    delivery: {
        path: "delivery",
        name: "delivery",
        meta: { title: "配送管理" },
        component: () => import("../views/order/delivery.vue"),
    },
    layout: {
        path: "layout",
        name: "layout",
        meta: { title: "排版管理" },
        component: () => import("../views/file/layout.vue"),
    },
    print: {
        path: "print",
        name: "print",
        meta: { title: "打印" },
        component: () => import("../views/order/print.vue"),
    },
    otherFileSettings: {
        path: "otherFileSettings",
        name: "otherFileSettings",
        meta: { title: "其他文件设置" },
        component: () => import("../views/set/otherFileSettings.vue"),
    },

    otherFile: {
        path: "otherFile",
        name: "otherFile",
        meta: { title: "其他文件设置" },
        component: () => import("../views/file/otherFile.vue"),
    },
    piecework: {
        path: "piecework",
        name: "piecework",
        meta: { title: "其他文件设置" },
        component: () => import("../views/order/piecework.vue"),
    },

    special: {
        path: "special",
        name: "special",
        meta: { title: "特殊工艺设置" },
        component: () => import("../views/set/special.vue"),
    },

    trade: {
        path: "trade",
        name: "trade",
        meta: { title: "营业情况" },
        component: () => import("../views/order/trade.vue"),
    },

    operator: {
        path: "operator",
        name: "operator",
        meta: { title: "业务下单" },
        component: () => import("../views/order/operator.vue"),
    },

    pieceCount: {
        path: "pieceCount",
        name: "pieceCount",
        meta: { title: "生成计件" },
        component: () => import("../views/order/pieceCount.vue"),
    },

    reconciliation: {
        path: "reconciliation",
        name: "reconciliation",
        meta: { title: "客户对账" },
        component: () => import("../views/order/reconciliation.vue"),
    },

    quotation: {
        path: "quotation",
        name: "quotation",
        meta: { title: "报价设置" },
        component: () => import("../views/set/quotation.vue"),
    },

    reckon: {
        path: "reckon",
        name: "reckon",
        meta: { title: "计件管理" },
        component: () => import("../views/order/reckon.vue"),
    },

    collage: {
        path: "collage",
        name: "collage",
        meta: { title: "拼版设置" },
        component: () => import("../views/set/collage.vue"),
    },

    ordinary: {
        path: "ordinary",
        name: "ordinary",
        meta: { title: "普通切割设置" },
        component: () => import("../views/set/ordinary.vue"),
    },

    borderless: {
        path: "borderless",
        name: "borderless",
        meta: { title: "无边字面板" },
        component: () => import("../views/set/borderless.vue"),
    },

    superSet: {
        path: "superSet",
        name: "superSet",
        meta: { title: "超级字" },
        component: () => import("../views/set/superSet.vue"),
    },

    pointConsme: {
        path: "pointConsme",
        name: "pointConsme",
        meta: { title: "积分记录" },
        component: () => import("../views/set/pointConsme.vue"),
    },

    member: {
        path: "member",
        name: "member",
        meta: { title: "会员" },
        component: () => import("../views/set/member.vue"),
    },

    recharge: {
        path: "recharge",
        name: "recharge",
        meta: { title: "会员" },
        component: () => import("../views/set/recharge.vue"),
    },
    inventory: {
        path: "inventory",
        name: "inventory",
        meta: { title: "积分记录" },
        component: () => import("../views/material/inventory.vue"),
    },
    stock: {
        path: "stock",
        name: "stock",
        meta: { title: "积分记录" },
        component: () => import("../views/material/stock.vue"),
    },

    backlit: {
        path: "backlit",
        name: "backlit",
        meta: { title: "背光字" },
        component: () => import("../views/set/backlit.vue"),
    },

    retouchingFile: {
        path: "retouchingFile",
        name: "retouchingFile",
        meta: { title: "背光字" },
        component: () => import("../views/file/retouchingFile.vue"),
    },

    process: {
        path: "process",
        name: "process",
        meta: { title: "特殊工艺" },
        component: () => import("../views/set/process.vue"),
    },
    inventory: {
        path: "inventory",
        name: "inventory",
        meta: { title: "库存料头" },
        component: () => import("../views/file/inventory.vue"),
    },
};

const createRouter = () =>
    new Router({
        routes: commonRoutes,
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
